import "@fontsource/oswald";
import HeaderBlue from '../../components/HeaderBlue';
import FooterBlue from '../../components/FooterBlue';

const AboutUs = () => {
    return (
        <div className="flex flex-col min-h-screen bg-gray-100 text-gray-900">
            <HeaderBlue />
            <section className="w-full py-60 relative bg-cover bg-top px-3 mb-4"
                style={{
                    backgroundImage: "url('./assets/aboutus.webp')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl staffx text-shadow font-oswald pb-5" >SIMPLIFYING HIRING FOR EVERYONE</h2>
                    <p className="text-white text-xl  interfont font-oswald">
                        Connecting Fleets and Drivers Directly. <br />No middlemen. No hidden fees. Just faster, smarter recruiting.
                    </p>
                </div>
            </section>
            <section>
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 justify-center items-center md:h-screen gap-10">
                    <div className="max-w-4xl mx-auto">
                        <h2 className="font-bold text-gray-800 mb-8 staffx" style={{ fontSize: 50, }}>About Us</h2>
                        <p className="text-lg text-gray-600 interfont mb-4">
                            At <span className="font-semibold text-primary">Fleety</span>, we’re redefining driver recruiting with a focus on simplicity,
                            speed, and transparency. We know how critical it is for fleets to stay on the road—and how frustrating traditional
                            staffing methods can be. That’s why we’ve built a better way to connect carriers with qualified drivers—without the middlemen,
                            inflated costs, or red tape.
                        </p>
                        <p className="text-lg text-gray-600 mb-8 interfont">
                            Our approach is direct and effective. We connect carriers with vetted, ready-to-drive talent using modern tools, clear communication,
                            and a team that understands the industry from the ground up. No hidden fees. No endless back-and-forth. Just drivers where and when you
                            need them.
                        </p>
                        <div className="bg-black text-white p-8 rounded-lg shadow-lg">
                            <p className="text-xl italic">
                                Whether you're a small fleet or a nationwide carrier, Truckers makes it easier to find the right drivers—faster.
                            </p>
                            <p className="mt-4 font-semibold">— Team Fleety</p>
                        </div>
                    </div>
                    <div>
                        <img src="assets/2373small.webp" className="mx-auto" alt="Truckers Team" />
                    </div>
                </div>
            </section>
            <section className="bg-slate-200 py-20">
                <div className="container mx-auto px-6">
                    <h2 className=" font-bold text-gray-200 text-center staffx pb-6" style={{ fontSize: 50, }}>What We Do</h2>
                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center">
                            <div className="rounded-full flex items-center justify-center mb-4">
                                <img src="assets/aboutp3.png" className="w-2/3 mx-auto" alt="Direct Connections" />
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-blue-600">Direct Connections</h3>
                            <p className="text-gray-600 ">
                                Our platform eliminates thrid party by connecting Carriers directly with reliable drivers, reducing costs and increasing efficiency.
                            </p>
                        </div>
                        <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center">
                            <div className="rounded-full flex items-center justify-center mb-4">
                                <img src="assets/TRANSPARENT-PRICING.png" className="w-2/3 mx-auto" alt="Transparent Pricing" />
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-blue-600">Transparent Pricing</h3>
                            <p className="text-gray-600">
                                One simple monthly fee gives you unlimited access to a variety of services, no hidden cost & surprise charges.
                            </p>
                        </div>
                        {/* <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow text-center">
                            <div className="rounded-full flex items-center justify-center mb-4">
                                <img src="assets/aboutp1.png" className="w-2/3 mx-auto" alt="Efficient Logistics" />
                            </div>
                            <h3 className="text-xl font-semibold mb-3 text-blue-600">Efficient Logistics</h3>
                            <p className="text-gray-600 text-lg">
                                Our intuitive platform makes finding loads or trucks quick and easy, saving time for both Carriers and Drivers.
                            </p>
                        </div> */}
                    </div>
                </div>
            </section>

            <section
                className="py-16 md:h-screen  items-center relative"
                style={{
                    backgroundImage: "url('./assets/linesres.webp')",
                    backgroundSize: 'cover'
                }}
            >
                <div className='absolute bg-white bg-opacity-75 w-full h-full z-0 top-0'></div>
                <div className="container mx-auto px-6 absolute z-10">
                    <h2 className=" font-bold text-gray-800 mb-12  ml-28 staffx" style={{ fontSize: 50, }}>Why Fleets and Drivers Choose Us</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
                        <img
                            src="assets/abtimg2.jpg"
                            alt="Why Choose Us"
                            className="w-2/3 mx-auto rounded-2xl"
                        />
                        <div className="space-y-16">
                            <div>
                                <h3 className="text-xl font-semibold mb-2 text-gray-800">More Earnings for Drivers</h3>
                                <p className="text-gray-600">
                                    We don’t believe in middlemen taking a cut of your paycheck. Our direct-hire model <br />connects drivers with fleets—no staffing
                                    fees or markups—so you take home more of what you earn.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2 text-gray-800">Verified Fleets & Drivers</h3>
                                <p className="text-gray-600">
                                    Every fleet and driver we work with is carefully screened. From insurance and safety records to active <br />
                                    authority and employment history, we ensure every match is built on trust and transparency.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2 text-gray-800">Reliable Hiring for Fleets</h3>
                                <p className="text-gray-600">
                                    Say goodbye to empty trucks. We provide fleets with consistent access to qualified drivers
                                    <br />ready to hit the road. No delays, no excuses—just dependable hiring when you need it.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-16 bg-slate-200  text-black">
                <div className="container mx-auto px-6 text-center">
                    <h2 className="text-3xl font-bold mb-6">Ready to Simplify Your Freight?</h2>
                    <p className="text-xl mb-8 mx-auto">
                        Join hundreds of Carriers and drivers who are already benefiting from direct, transparent connections.
                    </p>
                </div>
            </section>
            <FooterBlue />
        </div>
    );
};

export default AboutUs;
